import React__default, { useState, useEffect } from 'react';
import { TaktIdProvider, createStormTaktId, IconButton } from '@amzn/storm-ui';
import { H as HelpMeHereIconButtonWrapper, c as HelpMeHereNotificationsCounter } from '../FocusPageHeader.styles-DygDK2r5.js';
import { u as useIntl } from '../../LocalModules/storm-ui-intl/dist/esm/3rdPartyModules/react-intl/lib/src/components/useIntl-voJ4yxcS-DU7lWLPF.js';
import { f as faQuestionCircle } from '../../LocalModules/storm-ui-icons/dist/esm/fortawesome-free-regular-svg-icons-CxUne8It-DdObqI9E.js';

const HMH_OPEN_FLYOVER = 'hmh_open_flyover';
const HMHConsistentIngressAnchor = ({
  applicationName,
  taktId,
  taktValue
}) => {
  const {
    formatMessage
  } = useIntl();
  const [notificationNumber, setNotificationNumber] = useState(0);
  useEffect(() => {
    const notificationChannel = new BroadcastChannel('ContactUsNotifications');
    const handleMessage = event => {
      setNotificationNumber(event.data);
    };
    notificationChannel.addEventListener('message', handleMessage);
    return () => {
      notificationChannel.removeEventListener('message', handleMessage);
      notificationChannel.close();
    };
  }, []);
  const dispatchOpenEvent = () => {
    const openEvent = new CustomEvent(HMH_OPEN_FLYOVER, {
      detail: {
        applicationName
      }
    });
    document.dispatchEvent(openEvent);
  };
  if (window.location.href.includes('/help')) return null;
  return /*#__PURE__*/React__default.createElement(TaktIdProvider, {
    taktId: taktId,
    taktValue: taktValue,
    fallbackId: createStormTaktId('focus-page-header')
  }, /*#__PURE__*/React__default.createElement(HelpMeHereIconButtonWrapper, null, /*#__PURE__*/React__default.createElement(IconButton, {
    onClick: dispatchOpenEvent,
    "data-testid": "hmh-consistent-ingress",
    variant: "transparent",
    icon: faQuestionCircle,
    label: formatMessage({
      id: 'open-the-help-panel'
    }),
    "aria-label": formatMessage({
      id: 'open-the-help-panel'
    }),
    "aria-haspopup": "true"
  }), notificationNumber > 0 && /*#__PURE__*/React__default.createElement(HelpMeHereNotificationsCounter, {
    "data-testid": "hmh-notifications-counter",
    size: "xsmall"
  }, notificationNumber)));
};

export { HMHConsistentIngressAnchor as H };
//# sourceMappingURL=HMHConsistentIngressAnchor-CKgoIGCs.js.map
